export default {
  data() {
    return {
      form: {
        salutation: 'Mr.',
        first_name: '',
        last_name: '',
        street: '',
        house_number: '',
        zip: '',
        city: '',
        country_id: '',
        email: '',
        phone: '',
        fax: '',
      },
      validation: {},
    };
  },
  methods: {
    initProfileData() {
      this.form = {
        salutation: this.user.salutation || this.form.salutation,
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        street: this.user.street,
        house_number: this.user.house_number,
        zip: this.user.zip,
        city: this.user.city,
        country_id: this.user.country_id,
        email: this.user.email,
        phone: this.user.phone,
        fax: this.user.fax,
      };
    },
    initValidation() {
      this.validation = {
        first_name: {
          valid: null,
          message: '',
        },
        last_name: {
          valid: null,
          message: '',
        },
        street: {
          valid: null,
          message: '',
        },
        house_number: {
          valid: null,
          message: '',
        },
        zip: {
          valid: null,
          message: '',
        },
        city: {
          valid: null,
          message: '',
        },
        country_id: {
          valid: null,
          message: '',
        },
        email: {
          valid: null,
          message: '',
        },
        phone: {
          valid: null,
          message: '',
        },
      };
    },
    onSubmit() {
      this.initValidation();
      this.updateProfile(this.form);
    },
  },
  created() {
    this.initValidation();
    this.initProfileData();
  },
};
